import { render } from "./DataGrid.vue?vue&type=template&id=f852b866&scoped=true&ts=true"
import script from "./DataGrid.vue?vue&type=script&lang=ts"
export * from "./DataGrid.vue?vue&type=script&lang=ts"

import "./DataGrid.vue?vue&type=style&index=0&id=f852b866&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f852b866"]])

export default __exports__